/**
 * WONDR Safety Razor — UGC video cards (duration, controls, single active play)
 */
(function () {
  function formatDuration(seconds) {
    if (!Number.isFinite(seconds) || seconds <= 0) return '';
    var total = Math.round(seconds);
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function setCardDuration(card, video) {
    var text = formatDuration(video.duration);
    if (!text) return;

    var badge = card.querySelector('[data-wondr-srz-ugc-duration]');
    if (badge) {
      badge.textContent = text;
      badge.hidden = false;
    }

    var meta = card.querySelector('[data-wondr-srz-ugc-duration-meta]');
    var suffix = card.querySelector('[data-wondr-srz-ugc-zone-suffix]');
    if (meta) meta.textContent = text;
    if (suffix) suffix.hidden = false;
  }

  function syncVideoControls(video, card) {
    var playing = !video.paused && !video.ended;
    video.controls = playing;
    if (card) card.classList.toggle('is-playing', playing);
  }

  function pauseOtherVideos(section, activeVideo) {
    section.querySelectorAll('video.wondr-srz-ugc__video').forEach(function (v) {
      if (v !== activeVideo) v.pause();
    });
  }

  function bindCard(card) {
    var video = card.querySelector('video.wondr-srz-ugc__video');
    if (!video || card.dataset.wondrSrzUgcBound === 'true') return;
    card.dataset.wondrSrzUgcBound = 'true';

    syncVideoControls(video, card);
    video.addEventListener('play', function () {
      syncVideoControls(video, card);
    });
    video.addEventListener('pause', function () {
      syncVideoControls(video, card);
    });
    video.addEventListener('ended', function () {
      syncVideoControls(video, card);
    });

    if (video.readyState >= 1) {
      setCardDuration(card, video);
    } else {
      video.addEventListener(
        'loadedmetadata',
        function () {
          setCardDuration(card, video);
        },
        { once: true }
      );
    }
  }

  function bindSection(section) {
    if (section.dataset.wondrSrzUgcSectionBound === 'true') return;
    section.dataset.wondrSrzUgcSectionBound = 'true';

    section.addEventListener('click', function (e) {
      var card = e.target.closest('.wondr-srz-ugc__card');
      if (!card || !section.contains(card)) return;

      var video = card.querySelector('video.wondr-srz-ugc__video');
      if (!video) return;

      /* Only start playback from a paused/ended state; while playing, native controls handle pause/seek */
      if (!(video.paused || video.ended)) return;

      e.preventDefault();
      pauseOtherVideos(section, video);
      video.play().catch(function () {});
    });

    section.querySelectorAll('.wondr-srz-ugc__card').forEach(bindCard);
  }

  function initUgc(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.wondr-srz-ugc');
    if (scope.classList && scope.classList.contains('wondr-srz-ugc')) {
      bindSection(scope);
      return;
    }
    sections.forEach(bindSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initUgc();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initUgc(e.target);
  });
})();
